import { Link } from 'react-router-dom';
import { Container } from './styles';
import { BranchType } from '../../types';

interface ListHeaderInterface {
  entity: BranchType[];
  apiFetched: boolean;
  filteredEntity: BranchType[];
  linkPath: string;
  entityString: {
    singular: string;
    plural: string;
  };
}

export default function ListHeader({
  entity,
  apiFetched,
  filteredEntity,
  linkPath,
  entityString,
}: ListHeaderInterface) {
  return (
    <Container doesListExists={Boolean(entity)} apiFetched={apiFetched}>
      {(entity && apiFetched) && (
        <strong>
          {filteredEntity?.length}
          {' '}
          {filteredEntity?.length === 1 ? entityString.singular : entityString.plural}
        </strong>
      )}
      <Link to={linkPath}>Nova filial</Link>
    </Container>
  );
}
